import { MapSharedService } from './map-shared.service';
import { AttrIndexService } from './attr-index.service';
import { UserService } from './user.service';
import { EditService } from './edit.service';
import { AgencyInfoService } from './agency-info.service';
import { BehaviorSubject, Subject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "./agency-info.service";
import * as i2 from "./attr-index.service";
import * as i3 from "./edit.service";
import * as i4 from "./map-shared.service";
import * as i5 from "./user.service";
var EditFeatureService = /** @class */ (function () {
    function EditFeatureService(agencyInfoService, attrIndexService, editService, mapSharedService, userService) {
        this.agencyInfoService = agencyInfoService;
        this.attrIndexService = attrIndexService;
        this.editService = editService;
        this.mapSharedService = mapSharedService;
        this.userService = userService;
        this.showPolygonEditBS = new BehaviorSubject({
            showEditContextmenu: false
        });
        this.polygonEditSubject = new Subject();
        this.bdryWizardBS = new BehaviorSubject({
            isOn: false
        });
    }
    EditFeatureService.prototype.getAddressNumInterpolate = function (pointOnRoad, lineFeat, addrRange, parity) {
        var splitLine = this.mapSharedService.getSplitLineByPoint(lineFeat, pointOnRoad).first;
        var percent = splitLine.getLength() / lineFeat.getGeometry().getLength();
        var addrNum = addrRange[0] + (addrRange[1] - addrRange[0]) * percent;
        addrNum = this.roundAddressNumByParity(addrNum, parity); // Number(addrNum.toFixed(0));
        return addrNum;
    };
    EditFeatureService.prototype.roundAddressNumByParity = function (rawNum, parity) {
        var floor = Math.floor(rawNum);
        switch (parity) {
            case 'O':
                if (floor % 2 === 1) {
                    return floor;
                }
                else {
                    return floor + 1;
                }
            case 'E':
                if (floor % 2 === 0) {
                    return floor;
                }
                else {
                    return floor + 1;
                }
            default:
                return Math.round(rawNum);
        }
    };
    EditFeatureService.prototype.checkRoadRangeValid = function (range) {
        if (!range || range.length < 2) {
            return false;
        }
        if (range[0] === range[1]) {
            return false;
        }
        if ((!range[0] && range[0] !== 0) || (!range[1] && range[1] !== 0)) {
            return false;
        }
        return true;
    };
    EditFeatureService.prototype.carryOverCenterlineAttrsToAddress = function (lineAttrs, side, addressCate, centerlineCate, addrFeat, isRelocation) {
        var _this = this;
        var props = {};
        var cols = addressCate.standardCols;
        if (isRelocation) {
            cols = cols.filter(function (i) { return i.isFishboneCol || i.transferRclVal !== 'calc'; });
        }
        cols.forEach(function (i) {
            var lineCol;
            if (i.transferRclCol) {
                lineCol = centerlineCate.standardCols.find(function (c) { return c.colName === i.transferRclCol; });
            }
            var addrProp = addressCate.colPrefix + '_' + i.colName.toLowerCase();
            var prop = {};
            switch (i.transferRclVal) {
                case 'transfer':
                    var colName_1 = i.transferRclCol || i.colName;
                    lineCol = centerlineCate.standardCols.find(function (c) { return c.colName === colName_1; });
                    break;
                case 'parity':
                    var colNameWithSide_1 = i.transferRclCol + (side === 'left' ? '_l' : '_r');
                    lineCol = centerlineCate.standardCols.find(function (c) { return c.colName.toLowerCase() === colNameWithSide_1.toLowerCase(); });
                    break;
            }
            if (lineCol) {
                var lineColProp = centerlineCate.colPrefix + '_' + lineCol.colName.toLowerCase();
                prop[addrProp] = lineAttrs[lineColProp];
            }
            if (i.transferRclVal === 'calc') {
                switch (i.colName.toLowerCase()) {
                    case _this.attrIndexService.discrepancyAgencyIdStandardLower:
                        var discAgencyId = _this.userService.customerInfo.discrepancyId;
                        prop[addrProp] = discAgencyId;
                        break;
                    case _this.attrIndexService.dateUpdateCol.toLowerCase():
                        prop[addrProp] = _this.editService.convertDateToStr(new Date());
                        break;
                    case _this.attrIndexService.nguidCol.toLowerCase():
                        // const pattern = {
                        // 	layerType: this.agencyInfoService.getIsLayerTypeFromNguidPattern(this.userService.customerInfo.nguidPattern)
                        // }
                        var nguid = _this.agencyInfoService.computeNguid(addressCate.code);
                        prop[addrProp] = nguid;
                        break;
                    // todo: latitude/longitude
                }
            }
            if (addrFeat) {
                addrFeat.setProperties(prop);
            }
            if (prop[addrProp] !== undefined) {
                props[addrProp] = prop[addrProp];
            }
        });
        return props;
    };
    EditFeatureService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EditFeatureService_Factory() { return new EditFeatureService(i0.ɵɵinject(i1.AgencyInfoService), i0.ɵɵinject(i2.AttrIndexService), i0.ɵɵinject(i3.EditService), i0.ɵɵinject(i4.MapSharedService), i0.ɵɵinject(i5.UserService)); }, token: EditFeatureService, providedIn: "root" });
    return EditFeatureService;
}());
export { EditFeatureService };
